import { Component, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MaintenanceAlertItem, MaintenanceAlertService } from 'src/app/services/maintenance-alert.service';

@Component({
  selector: 'app-maintenance-alert',
  templateUrl: './maintenance-alert.component.html',
  styleUrls: ['./maintenance-alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('toastSlide', [
      transition(':enter', [
        style({ transform: 'translateX(110%)', opacity: 0 }),
        animate('320ms cubic-bezier(0.25, 0.8, 0.25, 1)',
          style({ transform: 'translateX(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('220ms ease-in',
          style({ transform: 'translateX(110%)', opacity: 0 }))
      ])
    ])
  ]
})
export class MaintenanceAlertComponent implements OnInit, OnDestroy {

  alerts: MaintenanceAlertItem[] = [];
  private sub!: Subscription;

  constructor(
    private readonly alertService: MaintenanceAlertService,
    private readonly cdr: ChangeDetectorRef,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.sub = this.alertService.alerts$.subscribe(alerts => {
      this.alerts = alerts;
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  dismiss(key: string): void {
    this.alertService.dismiss(key);
  }

  onAlertClick(alert: MaintenanceAlertItem): void {
    if (alert.type === 'sms') {
      this.alertService.dismiss(alert.key);
      this.router.navigate(['/nora/admin/settings/purchase']);
    }
  }

  trackByKey(_: number, item: MaintenanceAlertItem): string {
    return item.key;
  }
}
